import { render, staticRenderFns } from "./DefaultHeaderDropdownSetting.vue?vue&type=template&id=0b0abb5a&"
import script from "./DefaultHeaderDropdownSetting.vue?vue&type=script&lang=js&"
export * from "./DefaultHeaderDropdownSetting.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHeaderDropdownSetting.vue?vue&type=style&index=0&id=0b0abb5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports